import { render, staticRenderFns } from "./kexue.vue?vue&type=template&id=1419eb5a&scoped=true&"
import script from "./kexue.vue?vue&type=script&lang=js&"
export * from "./kexue.vue?vue&type=script&lang=js&"
import style0 from "./kexue.vue?vue&type=style&index=0&id=1419eb5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1419eb5a",
  null
  
)

export default component.exports